import { FormFieldControlled } from "components/UI/FormField/FormFieldControlled";
import { RequestTypeSelect } from "components/UI/RequestTypeSelect";
import { TransitTimeCheckboxGroupData } from "constants/checkboxGroupData.constants";
import { INPUT_FIELD_NAMES } from "constants/fieldNames.constans";
import { VALIDATION_SCHEMA } from "constants/validationSchema.constans";
import styles from "../index.module.scss";

export const TransitTimeApi = () => {
  return (
    <>
      <FormFieldControlled
        rules={VALIDATION_SCHEMA.toolInfo.required}
        labelTitle="How many API calls are you planning to make per month?"
        fieldName={INPUT_FIELD_NAMES.apiPerMonth}
      />
      <RequestTypeSelect
        rules={VALIDATION_SCHEMA.toolInfo.oneValue}
        fieldName={INPUT_FIELD_NAMES.transitTimeTransportTypes}
        label="Which transport types do you need data for?"
        placeholder="Select request type"
        options={TransitTimeCheckboxGroupData}
        className={styles.requestTypeSelect}
      />
    </>
  );
};
